import { Link, isRouteErrorResponse, useRouteError } from "react-router-dom";

// taken from https://reactrouter.com/en/main/utils/is-route-error-response
export default function ErrorBoundary() {
  const error = useRouteError();
  if (isRouteErrorResponse(error)) {
    console.debug("route error");
    return (
      <div>
        <h1>Oops!</h1>
        <h2>{error.status}</h2>
        <p>{error.statusText}</p>
        {error.data?.message && <p>{error.data.message}</p>}
        go to <Link to="/">home</Link>
      </div>
    );
  } else {
    console.debug("other error");
    return <div>Oops</div>;
  }
}
